import React from 'react';
import { Spin } from 'antd';
import useInfoReactions from '../../../../queries/useInfoReactions';
import { useSelector } from 'react-redux';
import { selectedInfoSelector } from '../../../../store/selectors';
import ViewCount from '../../../ViewCount/ViewCount';
import ReactionList from '../../../ReactionList/ReactionList';
import styles from './ViewAndReactions.module.scss';

const ViewAndReactions = () => {
  const selectedInfo = useSelector(selectedInfoSelector);

  const { data, isFetching } = useInfoReactions(selectedInfo?.id, {
    enabled: Boolean(selectedInfo),
  });

  return (
    <Spin spinning={isFetching}>
      <div className={styles.root}>
        <ReactionList reactions={data?.reactions || []} />
        <ViewCount count={data?.viewCount || 0} />
      </div>
    </Spin>
  );
};

export default ViewAndReactions;
